var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.disabled
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end mb-1" },
            [
              _c("action-button", {
                staticClass: "success",
                attrs: { i: "fas fa-save", text: "Guardar" },
                on: { click: _vm.save }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.disabled && !_vm.canSearch
        ? _c(
            "div",
            {
              staticClass: "d-flex justify-content-center mt-5 bg-secondary-13"
            },
            [
              _c("div", { staticClass: "w-35 py-3" }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center" },
                  [
                    _c("action-button", {
                      staticClass: "border w-100 btn",
                      attrs: {
                        i: "fas fa-file-plus color-primary-1",
                        text:
                          "Presione aquí para añadir Practicantes/Internos/Especialistas"
                      },
                      on: {
                        click: function($event) {
                          _vm.isSearchVisible = true
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm.canSearch
        ? _c("search", {
            attrs: {
              disabled: _vm.disabled,
              "on-specialist-selected": _vm.handleSpecialistSelected,
              "selected-specialist": _vm.selectedSpecialistIds
            }
          })
        : _vm._e(),
      _c("add", {
        attrs: {
          disabled: _vm.disabled,
          "on-remove-specialist": _vm.handleRemoveSpecialist
        },
        model: {
          value: _vm.selectedSpecialists,
          callback: function($$v) {
            _vm.selectedSpecialists = $$v
          },
          expression: "selectedSpecialists"
        }
      }),
      _vm.disabled && _vm.selectedSpecialistIds.length == 0
        ? _c("div", [_vm._m(0)])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-12 p-4 text-center align-items-center no-info mt-4" },
      [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-12 col-lg-1 align-self-center" }, [
            _c("i", {
              staticClass: "far fa-folder-open icon no-info-icon pl-2"
            })
          ]),
          _c(
            "div",
            { staticClass: "col-12 col-lg-3 ml-lg-n4 align-self-center" },
            [
              _c("span", { staticClass: "no-info-text" }, [
                _vm._v(
                  " El especialista no cuenta con información de Supervisión. "
                )
              ])
            ]
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }